export default "__VITE_ASSET__BXgPi_4c__"